<briefing-table [campaignId]="campaignId"
                [publicationId]="publication._id"
                [additionalColumns]="additionalColumns"
                [selectionMode]="ESelectionMode.MULTI"
                [selection]="selection"
                [tableId]="tableId"
                [assignableItems]="true"
                (itemsChanged)="setSelectedItems($event)">
</briefing-table>
